import { render, staticRenderFns } from "./EscolherEnderecoEntrega.vue?vue&type=template&id=7e6db516&"
import script from "./EscolherEnderecoEntrega.vue?vue&type=script&lang=js&"
export * from "./EscolherEnderecoEntrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports